<template>
  <div class="split-section px-2">
    <slot />
  </div>
</template>

<script lang="ts">
export default {};
</script>

<style lang="scss">
.split-section {
  margin: 2px;
  margin-top: -24px;
  background-color: #e4e4e4;
  border-top: 8px solid #f01614;
}

@media (max-width: 576px) {
  .split-section {
    margin-top: 14px;
  }
}
</style>